import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import API from "../../helpers/devApi";
import { swalError, swalSuccess } from "../../helpers/swal";

const ChangePassword = () => {
  const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  const [formData, setFormData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setAlertMsg();
    setIsAlert(false);

    let valid = true;
    var msg = "";
    if (formData.new_password && formData.confirm_password) {
      if (formData.new_password != formData.confirm_password) {
        msg =
          user?.language == "English"
            ? "New Password & Confirm Password must match."
            : "নতুন পাসওয়ার্ড এবং নতুন নিশ্চিতকরণ পাসওয়ার্ড অবশ্যই  একই হতে হবে";
        valid = false;
        setIsAlert(true);
        setAlertMsg(msg);
      }
    }
    if (!formData.confirm_password) {
      msg =
        user?.language == "English"
          ? "Confirm Password not be left blank."
          : "নতুন পাসওয়ার্ড নিশ্চিতকরণ খালি রাখতে পারেন না।";
      valid = false;
      setIsAlert(true);
      setAlertMsg("Confirm password not be left blank");
    }
    if (!formData.new_password) {
      msg =
        user?.language == "English"
          ? "New Password not be left blank."
          : "নতুন পাসওয়ার্ড খালি রাখতে পারেন না।";
      valid = false;
      setIsAlert(true);
      setAlertMsg(msg);
    }
    if (!formData.current_password) {
      valid = false;
      msg =
        user?.language == "English"
          ? "Current Password not be left blank."
          : "বর্তমান পাসওয়ার্ড খালি রাখতে পারেন না।";
      setIsAlert(true);
      setAlertMsg(msg);
    }

    var error_msg =
      user?.language == "English"
        ? "System has failerd to connect due to internet problem."
        : "সিস্টেম নেটওয়ার্ক সমস্যা হওয়ার কারণে কর্মচারী দখানোর জন্য ব্যর্থ হয়েছে।";
    var sccs_msg =
      user?.language == "English"
        ? "Password Updated Successfully."
        : "পাসওয়ার্ড সফলভাবে পরিবর্তন হয়েছে ";

    if (valid) {
      if (user) {
        setLoading(true);
        await API.post(`/ade_users/passwordReset/${user.id}`, {
          current_password: formData.current_password,
          new_password: formData.new_password,
        })
          .then(async (res) => {
            setLoading(false);
            if (res.data.success) {
              swalSuccess(res.data.data?.message);
              swalSuccess(sccs_msg);
            } else {
              swalError(error_msg);
            }
          })
          .catch((error) => {
            swalError(error_msg);
          });
      } else {
        swalError(error_msg);
      }
    }
  };

  return (
    <div className="p-3">
      <div className="alert change-password-box col-sm-12 text-align-center">
        <strong className="ng-tns-c8-1">
          {" "}
          {user?.language == "English"
            ? "Reset Password"
            : "পাসওয়ার্ড পরিবর্তন"}
        </strong>
      </div>
      <div className="pt-3 form-box">
        <form>
          <div className="row pt-3">
            <div className="col-md-3">
              <label className="form-control-label">
                {" "}
                <b>
                  {" "}
                  {user?.language == "English"
                    ? "Current Password"
                    : "বর্তমান পাসওয়ার্ড "}{" "}
                  : <span style={{ color: "red" }}>*</span>
                </b>
              </label>
            </div>
            <div className="col-md-3">
              <input
                type="password"
                name="current_password"
                onChange={(e) => handleChange(e)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row pt-3">
            <div className="col-md-3">
              <label className="form-control-label">
                {" "}
                <b>
                  {" "}
                  {user?.language == "English"
                    ? "New Password"
                    : "নতুন পাসওয়ার্ড "}{" "}
                  : <span style={{ color: "red" }}>*</span>
                </b>
              </label>
            </div>
            <div className="col-md-3">
              <input
                type="password"
                name="new_password"
                onChange={(e) => handleChange(e)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row pt-3">
            <div className="col-md-3">
              <label className="form-control-label">
                {" "}
                <b>
                  {" "}
                  {user?.language == "English"
                    ? "Confirm Password"
                    : "নতুন পাসওয়ার্ড নিশ্চিতকরণ"}
                  : <span style={{ color: "red" }}>*</span>
                </b>
              </label>
            </div>
            <div className="col-md-3">
              <input
                type="password"
                name="confirm_password"
                onChange={(e) => handleChange(e)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row pt-3">
            {isAlert && (
              <div className="col-md-4 alert password-warning">
                <i className="fa-solid fa-triangle-exclamation triangle-exclamation"></i>{" "}
                &nbsp;
                <strong>{alertMsg}</strong>
              </div>
            )}
          </div>
          <div className="row pt-3">
            <div className="col-md-3"></div>
            <div className="col-md-3">
              <button
                type="button"
                disabled={loading}
                onClick={(e) => handleSubmit(e)}
                className="btn btn-default"
                // style={{ marginLeft: "130px" }}
              >
                {user?.language == "English" ? "Submit" : "সংরক্ষণ করুন"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default ChangePassword;
